import SwiperInstanceComponent from 'customs/swiper-instance-component'
import { getData } from 'helpers/dom'
import './carousel-swiper.css'

class CarouselSwiper extends HTMLElement {
  constructor() {
    super()

    this.config = this.getAttribute('data-config')
      ? JSON.parse(getData('config', this))
      : null
    this.options = this.getAttribute('data-options')
      ? JSON.parse(getData('options', this))
      : null

    if (this.config && this.options) {
      const renderFraction = (currentClass = '', totalClass = '') => {
        return `<span class="${currentClass}"></span> of <span class="${totalClass}"></span>`
      }

      if (this.options?.pagination?.type === 'fraction') {
        this.options = {
          ...this.options,
          pagination: {
            ...this.options.pagination,
            renderFraction
          }
        }
      } else {
        this.options = {
          ...this.options
        }
      }

      this.instance = new SwiperInstanceComponent(
        this,
        this.options,
        this.config
      )
    }
  }
}

if (!customElements.get('carousel-swiper')) {
  customElements.define('carousel-swiper', CarouselSwiper)
}
